<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitImportInvoiceFile">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('documents.document') }} <span class="required"> *</span></label>
          <div class="col-sm-7">
            <input ref="file" type="file" accept=".xlsx, .csv" @change="onFileChange" @input="$v.attachmentData.file.$touch()">
            <span class="form-group__message text-danger">{{ $t('documents.documentSizelessthan5MB') }}</span>
            <div v-if="$v.attachmentData.file.$error">
              <span v-if="!$v.attachmentData.file.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeImportInvoiceFileModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          :disabled="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ $t('general.save') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      file: null,
      documentTypes: [],
      selectedFile: null,
      isLoading: false,
      attachmentData: {
        file: null
      }
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ])
  },
  created () {},
  validations: {
    attachmentData: {
      file: {
        required
      }
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('preapprovedinvoice', [
      'importPaymentInvoice'
    ]),
    onFileChange (e) {
      this.isLoading = true
      if (e.target.files[0].size >= 1048576 * 5) {
        window.toastr['error'](this.$t('documents.documentSizeExceed5MB'))
        this.$refs.file.value = ''
        this.isLoading = false
      } else {
        this.selectedFile = e.target.files[0]
        this.attachmentData.file = e.target.files[0]
        this.isLoading = false
      }
    },
    resetFormData () {
      this.attachmentData = {
        file: null
      }
      this.$v.attachmentData.$reset()
    },
    async submitImportInvoiceFile () {
      this.$v.attachmentData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      let data = new FormData()
      data.append('document', this.selectedFile)
      this.isLoading = true
      let res = await this.importPaymentInvoice(data)
      if (res.data.result === 'success') {
        this.isLoading = false
        this.closeImportInvoiceFileModal()
      } else if (res.data.result === 'error') {
        window.toastr['error'](res.data.message)
      }
    },
    closeImportInvoiceFileModal () {
      this.$router.go('/supplier/items')
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>
